// extracted by mini-css-extract-plugin
export default {"textClassName":"fJle8","circleClassName":"pdI9s","regionClassName":"URMC_"};